import { render, staticRenderFns } from "./ElectronicInvoice.vue?vue&type=template&id=0127734a&scoped=true&"
import script from "./ElectronicInvoice.vue?vue&type=script&lang=js&"
export * from "./ElectronicInvoice.vue?vue&type=script&lang=js&"
import style0 from "./ElectronicInvoice.vue?vue&type=style&index=0&id=0127734a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0127734a",
  null
  
)

export default component.exports